import { createContext, useContext } from 'react';

/**
 * AdminContext — partagé entre toutes les pages du dashboard admin.
 * Toutes les valeurs (state, setters, fonctions API) sont injectées
 * par AdminProvider dans AppAdmin.jsx.
 */
export const AdminContext = createContext({});

/**
 * useAdmin() — hook pour consommer le contexte dans n'importe quel
 * composant page extrait dans src/pages/
 */
export const useAdmin = () => useContext(AdminContext);
